import { ActivitiesPageFilters } from "domain/entities/activities.entities";
import { createAppAsyncThunk } from "domain/store.thunk";

export const getTutorials = createAppAsyncThunk(
  "tutorials/getTutorials",
  async (
    filters: Partial<ActivitiesPageFilters> & Partial<{ search: string }>,
    { extra: { tutorialsGateway } }
  ) => {
    return await tutorialsGateway.getTutorials(filters);
  }
);

export const setIsTutorialLoading = createAppAsyncThunk(
  "tutorials/setIsTutorialLoading",
  async (isLoading: boolean, { extra: { tutorialsGateway } }) => {
    return { isLoading };
  }
);

export const getTutorial = createAppAsyncThunk(
  "tutorials/getTutorial",
  async (id: number, { extra: { tutorialsGateway } }) => {
    return await tutorialsGateway.getTutorial(id);
  }
);

export const getFavoritesTutorials = createAppAsyncThunk(
  "techniques/getFavoritesTutorials",
  async (tutorialIds: number[], { extra: { tutorialsGateway } }) => {
    return await tutorialsGateway.getFavoritesTutorials(tutorialIds);
  }
);

export const getTutorialByInnizRef = createAppAsyncThunk(
  "tutorials/getTutorial",
  async (innizRef: number, { extra: { tutorialsGateway } }) => {
    return await tutorialsGateway.getTutorialByInnizRef(innizRef);
  }
);

export const getRandomTutorial = createAppAsyncThunk(
  "tutorials/getRandomTutorial",
  async (_, { extra: { tutorialsGateway } }) => {
    return await tutorialsGateway.getRandomTutorial();
  }
);
